import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { baseUrl } from "constant";
import { getAuthToken } from "utils/getAuthToken";
import { RootState } from "store/store";
import { IAttendanceDataListResponse, IAttendanceRequest, IBiometricInfo, IEditBiometricType } from "../types";
import { AttendanceEndpointConst, getBiometricUserByIdUrl } from "./const";
import { handlingErrorResponse } from "utils/HandlingErrorResponse";
import { IGetBiometricResponse, IRequestType, IResponseType } from "./type";


export const AttendanceApi= createApi({
    reducerPath: 'attendanceApi',
    baseQuery:fetchBaseQuery({
        baseUrl:baseUrl,
        prepareHeaders:(headers, {getState})=> {
            const token=getAuthToken(getState() as RootState)
            if(token){
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['Attendance'],
    endpoints: (builder)=>({
        GetAttendanceList: builder.mutation<IAttendanceDataListResponse,IAttendanceRequest>({
            query: userReq => ({
                url: AttendanceEndpointConst.attendanceList,
                method: 'POST',
                body: userReq   
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'Attendance', id: 'GetAttendanceList' }],
        }),
        EditBiometricDetails: builder.mutation<IResponseType<number>,IBiometricInfo>({
            query: userReq => ({
                url: AttendanceEndpointConst.biometricUpdate,
                method: 'POST',
                body: userReq.biometicObj 
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'Attendance', id: 'GetAttendanceList' }],
        }),
        GetBiometricUserById: builder.query<IGetBiometricResponse, IRequestType>({
            query: (employeeParams) => getBiometricUserByIdUrl(employeeParams),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'Attendance', id: 'GetBiometricUserById' }]
        }),
    })
    
})